module.exports = __webpack_public_path__ + "img/banner.40f2a974.png";